import { apiClient } from './apiClient';
const State = () => apiClient('/silverblue_otp.py.states.get_states', 'GET');
const Country = () => apiClient('/silverblue_otp.utils.commonAPIs.fetch_countries', 'GET');
const BusinessType = () => apiClient('/retailer_app.api.login.get_industry_type_list', 'GET');
const CustomerGroup = () => apiClient('/retailer_app.api.login.get_customer_group_list', 'GET');

export const GlobalService = {
  State,
  Country,
  BusinessType,
  CustomerGroup,
};
